module.exports = __webpack_public_path__ + "img/messina_progetto.19393bcc.png";